package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_03_14_Day_1
import com.veldekar.components.logs.Log_2026_03_14_Day_2
import com.veldekar.components.logs.Log_2026_03_14_Day_3
import com.veldekar.components.logs.Log_2026_03_14_Day_4
import com.veldekar.components.logs.Log_2026_03_14_Day_5
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-03-14")
@Composable
public fun Log_2026_03_14(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "The Most Delicious City in Veldekar",
        ogTitle = "The Most Delicious City in Veldekar",
        date = LocalDate(2_026, 3, 14),
        aiHint = "Image, title, and description are a joke about how the city had a perfectly circular map.",
        ogDescription = "On Pi Day, the heroes reach Kostigan — a pie‑shaped city perched on a cliff, its “crust” walls protecting a filling of craftsmen, travelers, and Bigglesworth’s stash of fish.",
        ogImage = "images/kostiganIsPie_preview.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A hand-drawn illustration of an island shaped like a large lattice-top pie.",
    ) {
        SessionDayHeader(dayId = "shimmer-15", dateString = "Shimmer 15")
        Log_2026_03_14_Day_1()
        SessionDayHeader(dayId = "shimmer-16", dateString = "Shimmer 16")
        Log_2026_03_14_Day_2()
        SessionDayHeader(dayId = "shimmer-17", dateString = "Shimmer 17")
        Log_2026_03_14_Day_3()
        SessionDayHeader(dayId = "shimmer-18", dateString = "Shimmer 18")
        Log_2026_03_14_Day_4()
        SessionDayHeader(dayId = "shimmer-20", dateString = "Shimmer 20")
        Log_2026_03_14_Day_5()
        SessionMediaItem(
            image = "images/kostiganIsPie.webp",
            linkImage = "images/kostiganIsPie.webp",
            description = "A hand-drawn illustration of an island shaped like a large lattice-top pie.",
            width = 3_967,
            height = 2_783,
        )
    }
}
